window.wishlistDebug = false;

var iWishCnt = 0,
  iWishlistmain = {},
  iWishsync = !1,
  iWishUrl = "https://iwish.myshopapps.com/ajax/";
if (void 0 === iwishWrapperClass) var iwishWrapperClass = "form";
if (void 0 === iWishVarSelector) var iWishVarSelector = "[name=id]";
if (void 0 === iWishQtySelector) var iWishQtySelector = "[name=quantity]";
if (void 0 === iWishSelectClass) var iWishSelectClass = "#product-select, .single-option-selector, .single-option-selector__radio, select[id|='product-select'], select[id|='product-variants-option'], select[id|='variant-listbox-option']";

function iWishPost(i, s) {
  wishlistDebug && console.log('iWishPost', i, s);
  method = "post";
  var e = document.createElement("form");
  e.setAttribute("method", method), e.setAttribute("action", i);
  for (var t in s)
    if (s.hasOwnProperty(t)) {
      var n = document.createElement("input");
      n.setAttribute("type", "hidden"), n.setAttribute("name", t), n.setAttribute("value", s[t]), e.appendChild(n)
    } document.head.appendChild(e), e.submit()
}

function getSession() {
  wishlistDebug && console.log('getSession');
  "undefined" != typeof Storage && ("" == iwish_cid && "true" == localStorage.iWishsync && (localStorage.removeItem("iWishlistmain"), localStorage.removeItem("iWishCnt"), localStorage.removeItem("iWishsync")), localStorage.iWishlistmain && (iWishlistmain = JSON.parse(localStorage.getItem("iWishlistmain"))), localStorage.iWishCnt && !isNaN(localStorage.iWishCnt) && (iWishCnt = parseInt(localStorage.iWishCnt)), localStorage.iWishsync && parseInt(iwish_cid) > 0 && "true" == localStorage.iWishsync && (iWishsync = !0), localStorage.setItem("iWishsync", iWishsync))
}

function pushToSession() {
  wishlistDebug && console.log('pushToSession');
  "undefined" != typeof Storage && ("undefined" !== iWishlistmain && localStorage.setItem("iWishlistmain", JSON.stringify(iWishlistmain)), "undefined" !== iWishCnt && localStorage.setItem("iWishCnt", iWishCnt))
}

function isInWishlist(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('isInWishlist', i, s);

  if (s) {
    return !!iWishlistmain[i]?.length && null != s && (iWishlistmain[i].indexOf(s) >= 0 || iWishlistmain[i].indexOf(parseInt(s)) >= 0);
  }

  return !!iWishlistmain[i]?.length;
}

function syncWithServer() {
  wishlistDebug && console.log('syncWithServer');
  var i = JSON.stringify(iWishlistmain);
  jQuery.ajax({
    url: iWishUrl + "syncWishlist.php",
    data: {
      shop: iwish_shop,
      cId: iwish_cid,
      iwishlist: i
    },
    dataType: "jsonp",
    jsonpCallback: "iWishSyncCallback",
    success: function(i) {
      console.log(JSON.stringify(i)), jQuery.extend(iWishlistmain, i.jsonDt), iWishCnt = i.iwishCnt, pushToSession(), jQuery(".iWishCount").html(iWishCnt), console.log("iWishsync done :: " + JSON.stringify(iWishlistmain)), iWishsync = !0, localStorage.setItem("iWishsync", iWishsync), "undefined" != typeof iWishsyncFn && "function" == typeof iWishsyncFn && iWishsyncFn()
    },
    error: function(i, s, e) {}
  })
}

function checkIwish(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('checkIwish', i, s);
  var e = i.find(".iWishAdd"),
    t = e.attr("data-product"),
    n = isInWishlist(t, s);
  console.log("checkIwish " + t + " :: " + s), n ? e.addClass("iwishAdded").html(iwish_added_txt) : e.removeClass("iwishAdded").html(iwish_add_txt), "undefined" != typeof iWishSelectChangeFn && "function" == typeof iWishSelectChangeFn && iWishSelectChangeFn(e)
}

function iwish_addOnly(i, s, e, t) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_addOnly', i, s, e, t);
  if (void 0 === iWishlistmain[i] && (iWishlistmain[i] = []), console.log("Adding " + i + " :: " + s), iWishlistmain[i].indexOf(s) < 0 && (iWishlistmain[i].push(s), iWishCnt++, pushToSession(), jQuery(".iWishCount").html(iWishCnt), parseInt(iwish_cid) > 0)) {
    var n = 1;
    t.parents(iwishWrapperClass).find(iWishQtySelector).length > 0 && (n = t.parents(iwishWrapperClass).find(iWishQtySelector).val()), jQuery.ajax({
      url: iWishUrl + "iwishAdd.php",
      data: {
        shop: iwish_shop,
        cId: iwish_cid,
        pId: i,
        vId: s,
        pTitle: e,
        qty: n
      },
      dataType: "jsonp",
      jsonpCallback: "iWishAddCallback",
      success: function(i) {},
      error: function(i, s, e) {}
    })
  }
}

function iwish_add(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_add', i, s);
  var e = i.attr("data-product");
  if (i.hasClass("iwishAdded") || null == s || null == e) return !1;
  if (iwish_addOnly(e, s, i.attr("data-pTitle"), i), iWishlistmain[e].indexOf(s) >= 0 && (i.addClass("iwishAdded").html(iwish_added_txt), "" == iwish_cid)) {
    var t = i.parents(iwishWrapperClass);
    t.find(".iWishLoginMsg").fadeIn(500), setTimeout(function() {
      t.find(".iWishLoginMsg").fadeOut()
    }, 6e3)
  }
  "undefined" != typeof iWishAddFn && "function" == typeof iWishAddFn && iWishAddFn()
}

function iwish_addCollection(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_addCollection', i, s);
  var e = i.attr("data-product");
  if (i.hasClass("iwishAdded") || null == s || null == e) return !1;
  iwish_addOnly(e, s, i.attr("data-pTitle"), i), iWishlistmain[e].indexOf(s) >= 0 && i.addClass("iwishAdded").html(iwish_added_txt_col), "undefined" != typeof iWishaddCollFn && "function" == typeof iWishaddCollFn && iWishaddCollFn()
}

function iwish_remove(i, s, e) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_remove', i, s, e);
  var t = !1;
  if (pId = i.attr("data-product"), void 0 === iWishlistmain[pId]) return t;
  console.log("iwish remove :: " + s);
  var n = iWishlistmain[pId].indexOf(s);
  n >= 0 && (iWishlistmain[pId].splice(n, 1), iWishCnt > 0 && iWishCnt--, jQuery(".iWishCount").html(iWishCnt), pushToSession(), 0 == (e = e || !1) && i.removeClass("iwishAdded"), parseInt(iwish_cid) > 0 && jQuery.ajax({
    url: iWishUrl + "iwishRemove.php",
    data: {
      shop: iwish_shop,
      cId: iwish_cid,
      pId: pId,
      vId: s
    },
    dataType: "jsonp",
    jsonpCallback: "iWishRemoveCallback",
    success: function(i) {},
    error: function(i, s, e) {}
  }), t = !0);
  return "undefined" != typeof iWishRemoveFn && "function" == typeof iWishRemoveFn && iWishRemoveFn(), t
}

function iwish_initQV() {
  s = s?.toString();
  wishlistDebug && console.log('iwish_initQV');
  setTimeout(function() {
    if (jQuery(iwish_qvWrapper + ":visible").find(".iWishAdd").length > 0) {
      var i = jQuery(iwish_qvWrapper + ":visible").find(iWishVarSelector).val();
      "" != i && checkIwish(jQuery(iwish_qvWrapper + ":visible").find(iwishWrapperClass), i), "undefined" != typeof iWishQvFn && "function" == typeof iWishQvFn && iWishQvFn()
    } else iwish_initQV()
  }, 300)
}

function iwish_updateQty(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_updateQty');
  jQuery.ajax({
    url: iWishUrl + "iwishUpdateQty.php",
    data: {
      shop: iwish_shop,
      cId: iwish_cid,
      iwishpQty: s,
      vId: i
    },
    dataType: "jsonp",
    jsonpCallback: "iWishUpdateQtyCallback",
    success: function(i) {},
    error: function(i, s, e) {}
  }), "undefined" != typeof iwishUpdateQtyFn && "function" == typeof iwishUpdateQtyFn && iwishUpdateQtyFn()
}

function iwishInit() {
  wishlistDebug && console.log('iwishInit');
  var i = !!jQuery.fn.on;
  if (iwish_pro_template) {
    var s = jQuery(".iWishAdd:visible").parents(iwishWrapperClass),
      e = s.find(iWishVarSelector).val();
    "" != e && checkIwish(s, e)
  }
  jQuery(".iWishCount").html(iWishCnt), parseInt(iwish_cid) > 0 && (iWishsync || (console.log("Sync Need to be done"), syncWithServer())), "undefined" != typeof iwish_qvButton && "undefined" != typeof iwish_qvWrapper && (i ? jQuery("body").on("click", iwish_qvButton, function() {
    iwish_initQV()
  }) : jQuery("body").delegate(iwish_qvButton, "click", function() {
    iwish_initQV()
  })), i ? jQuery(document).on("change", iWishSelectClass, function() {
    selectedClass = jQuery(this).parents(iwishWrapperClass), setTimeout(function() {
      var i = selectedClass.find(iWishVarSelector).val();
      "" != i ? checkIwish(selectedClass, i) : selectedClass.removeClass("iwishAdded").html(iwish_add_txt)
    }, 400)
  }) : jQuery(document).delegate(iWishSelectClass, "change", function() {
    selectedClass = jQuery(this).parents(iwishWrapperClass), setTimeout(function() {
      var i = selectedClass.find(iWishVarSelector).val();
      "" != i ? checkIwish(selectedClass, i) : selectedClass.removeClass("iwishAdded").html(iwish_add_txt)
    }, 400)
  }), "undefined" != typeof iWishinitFn && "function" == typeof iWishinitFn && iWishinitFn(), jQuery(".iwishRemoveBtn").click(function() {
    if (jQuery(this).hasClass("iwishRemoved")) return !1;
    var i = jQuery(this).attr("data-variant");
    return iwish_remove(jQuery(this), i, !0) && (jQuery(this).addClass("iwishRemoved"), jQuery(this).parents(".iwishItem").remove(), jQuery(".iwishMsgSuccess").show(), setTimeout(function() {
      jQuery(".iwishMsgSuccess").fadeOut(), 0 == iWishCnt && jQuery(".iwishMsgInfo").fadeIn()
    }, 3e3)), !1
  }), jQuery("input[name=iwishProQuantity]").change(function() {
    var i = jQuery(this),
      s = parseInt(i.val()),
      e = i.parents(".iwishItem").find(iWishVarSelector).val();
    parseInt(iwish_cid) > 0 && (s > 0 ? (iwish_updateQty(e, s), i.parents(".iwishItem").find("[name=quantity]").val(s), i.addClass("iwishProQtyAdded"), setTimeout(function() {
      i.removeClass("iwishProQtyAdded")
    }, 2e3), i.parents(".iwishItem").find(".iwishQtyMsg").fadeIn().delay(3e3).fadeOut()) : (i.val(1).addClass("iwishProQtyError"), setTimeout(function() {
      i.removeClass("iwishProQtyError")
    }, 1e3)))
  })
}
getSession(), window.addEventListener ? window.addEventListener("load", iwishInit, !0) : window.attachEvent ? window.attachEvent("onload", iwishInit) : window.onload = iwishInit;

// pID, vID, pTitle
function iwish_standalone_add(i, s) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_standalone_add', i, s);
  if (void 0 === iWishlistmain[i] && (iWishlistmain[i] = []), console.log("Adding " + i + " :: " + s), iWishlistmain[i].indexOf(s) < 0 && (iWishlistmain[i].push(s), iWishCnt++, pushToSession(), jQuery(".iWishCount").html(iWishCnt), parseInt(iwish_cid) > 0)) {
    var n = 1;
    jQuery.ajax({
      url: iWishUrl + "iwishAdd.php",
      data: {
        shop: window?.theme?.shop?.permanent_domain,
        cId: window?.theme?.customer?.id,
        pId: i,
        vId: s,
        // pTitle: e,
        qty: n ? n : 1
      },
      dataType: "jsonp",
      jsonpCallback: "iWishAddCallback",
      success: function(i) {
        console.log(i);
      },
      error: function(i, s, e) {
        console.error('Error', i, s, e);
      }
    })
  }
}

function iwish_standalone_remove(pId, s, e) {
  s = s?.toString();
  wishlistDebug && console.log('iwish_standalone_remove', pId, s, e);
  var t = !1;
  if (!pId) {
    return t;
  }
  console.log("iwish remove :: " + s);
  var n = iWishlistmain[pId].indexOf(s);
  n >= 0 && (iWishlistmain[pId].splice(n, 1), iWishCnt > 0 && iWishCnt--, jQuery(".iWishCount").html(iWishCnt), pushToSession(), parseInt(iwish_cid) > 0 && jQuery.ajax({
    url: iWishUrl + "iwishRemove.php",
    data: {
      shop: iwish_shop,
      cId: iwish_cid,
      pId: pId,
      vId: s
    },
    dataType: "jsonp",
    jsonpCallback: "iWishRemoveCallback",
    success: function(i) {},
    error: function(i, s, e) {}
  }), t = !0);
  return "undefined" != typeof iWishRemoveFn && "function" == typeof iWishRemoveFn && iWishRemoveFn(), t
}

window.wishlistUtils = window.wishlistUtils || {};
window.wishlistUtils.addToWishlist = iwish_standalone_add;

// window.wishlistDebug = true;
